var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55112 28.8229C1.24054 26.3699 0 23.6187 0 19.159C0 11.3113 5.51175 4.27747 13.527 0.799805L15.5303 3.88957C8.0489 7.93451 6.58628 13.1835 6.00303 16.493C7.20767 15.8697 8.7847 15.6522 10.3303 15.7957C14.3772 16.1701 17.5672 19.4908 17.5672 23.6187C17.5672 25.7001 16.74 27.6962 15.2675 29.1679C13.7951 30.6397 11.798 31.4665 9.71566 31.4665C8.56407 31.4565 7.42597 31.2177 6.36763 30.7638C5.30929 30.31 4.35186 29.6502 3.55112 28.8229ZM25.984 28.8229C23.6734 26.3699 22.4328 23.6187 22.4328 19.159C22.4328 11.3113 27.9446 4.27747 35.9598 0.799805L37.9631 3.88957C30.4817 7.93451 29.0191 13.1835 28.4359 16.493C29.6405 15.8697 31.2175 15.6522 32.7632 15.7957C36.8101 16.1701 40 19.4908 40 23.6187C40 25.7001 39.1728 27.6962 37.7004 29.1679C36.2279 30.6397 34.2309 31.4665 32.1485 31.4665C30.9969 31.4565 29.8588 31.2177 28.8005 30.7638C27.7421 30.31 26.7847 29.6502 25.984 28.8229Z",
    fill: "url(#paint0_linear_480_1212)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55112 28.8229C1.24054 26.3699 0 23.6187 0 19.159C0 11.3113 5.51175 4.27747 13.527 0.799805L15.5303 3.88957C8.0489 7.93451 6.58628 13.1835 6.00303 16.493C7.20767 15.8697 8.7847 15.6522 10.3303 15.7957C14.3772 16.1701 17.5672 19.4908 17.5672 23.6187C17.5672 25.7001 16.74 27.6962 15.2675 29.1679C13.7951 30.6397 11.798 31.4665 9.71566 31.4665C8.56407 31.4565 7.42597 31.2177 6.36763 30.7638C5.30929 30.31 4.35186 29.6502 3.55112 28.8229ZM25.984 28.8229C23.6734 26.3699 22.4328 23.6187 22.4328 19.159C22.4328 11.3113 27.9446 4.27747 35.9598 0.799805L37.9631 3.88957C30.4817 7.93451 29.0191 13.1835 28.4359 16.493C29.6405 15.8697 31.2175 15.6522 32.7632 15.7957C36.8101 16.1701 40 19.4908 40 23.6187C40 25.7001 39.1728 27.6962 37.7004 29.1679C36.2279 30.6397 34.2309 31.4665 32.1485 31.4665C30.9969 31.4565 29.8588 31.2177 28.8005 30.7638C27.7421 30.31 26.7847 29.6502 25.984 28.8229Z",
    fill: "black",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_480_1212",
    x1: -6.72223,
    y1: 64.4331,
    x2: -35.8918,
    y2: 32.3465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.5342dbb7ddb972c094df8e9199507625.svg";
export { ForwardRef as ReactComponent };